import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from "react";
import ReactTable from "react-table-6";
import withSFxFilter from "./TableHoc/withSFxFilter";
import 'react-table-6/react-table.css';

import { debounce } from "lodash";
import classnames from "classnames";
import Loading from "./Loading/index";
import NoData from "./NoData";
var ORDER_DIRECTION_ASC = 'asc';
var ORDER_DIRECTION_DESC = 'desc';
var prefix = "sfx-react-ui";

var transformOrderDirection = function transformOrderDirection(boolOrderDirection) {
  return boolOrderDirection === null ? null : boolOrderDirection ? ORDER_DIRECTION_DESC : ORDER_DIRECTION_ASC;
};

var ReactTableFilter = withSFxFilter(ReactTable);

var TableView = /*#__PURE__*/function (_Component) {
  _inherits(TableView, _Component);

  var _super = _createSuper(TableView);

  function TableView(props) {
    var _this;

    _classCallCheck(this, TableView);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      var columns = _this.props.columns;

      _this.setState({
        columns: columns
      });
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidUpdate", function (prevProps) {
      if (prevProps.columns !== _this.props.columns) {
        _this.setState({
          columns: _this.props.columns
        });
      }

      if (prevProps.pageIndex !== _this.props.pageIndex) {
        _this.setState({
          pageIndex: _this.props.pageIndex
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onFilteredChange", function (filtered) {
      var onFilteredChange = _this.props.onFilteredChange;
      onFilteredChange && onFilteredChange(filtered);
    });

    _defineProperty(_assertThisInitialized(_this), "onResizedChange", function (newResized, event) {
      var onResizedChange = _this.props.onResizedChange;
      onResizedChange && onResizedChange(newResized, event);
    });

    _defineProperty(_assertThisInitialized(_this), "onSortedChange", function (sorted) {
      var _sorted$ = sorted[0],
          orderId = _sorted$.id,
          desc = _sorted$.desc;
      var orderDirection = transformOrderDirection(desc);
      var onSortedChange = _this.props.onSortedChange;
      var _this$state = _this.state,
          pageIndex = _this$state.pageIndex,
          pageSize = _this$state.pageSize,
          filtered = _this$state.filtered;

      _this.setState({
        sorted: sorted,
        orderId: orderId,
        orderDirection: orderDirection
      });

      var sortedObj = {
        orderId: orderId,
        orderDirection: orderDirection,
        filtered: filtered,
        pageIndex: pageIndex,
        pageSize: pageSize
      };
      onSortedChange && onSortedChange(sortedObj);
    });

    _defineProperty(_assertThisInitialized(_this), "debouncedSortChange", debounce(_this.onSortedChange, 100));

    _defineProperty(_assertThisInitialized(_this), "onEditColumn", function () {
      var onEditColumn = _this.props.onEditColumn;
      onEditColumn && onEditColumn();
    });

    _defineProperty(_assertThisInitialized(_this), "onPageSizeChange", function (pageSize) {
      //use the props total to judge whether is backend pagination
      var _this$props = _this.props,
          total = _this$props.total,
          onChange = _this$props.onChange,
          onPageSizeChange = _this$props.onPageSizeChange; //the prevPageIndex start from 0

      var _this$state2 = _this.state,
          prevPageIndex = _this$state2.pageIndex,
          orderId = _this$state2.orderId,
          orderDirection = _this$state2.orderDirection,
          filtered = _this$state2.filtered;
      var totalPage = total && Math.ceil(total / pageSize);
      var newPageIndex = total && totalPage ? prevPageIndex >= totalPage ? totalPage - 1 : prevPageIndex : 0;

      _this.setState({
        pageSize: pageSize,
        pageIndex: newPageIndex
      }, function () {
        onChange && onChange({
          pageSize: pageSize,
          pageIndex: newPageIndex,
          orderId: orderId,
          orderDirection: orderDirection,
          filtered: filtered
        });
        onPageSizeChange && onPageSizeChange(pageSize);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onPageChange", function (pageIndex) {
      var _this$props2 = _this.props,
          onChange = _this$props2.onChange,
          onPageChange = _this$props2.onPageChange;
      var _this$state3 = _this.state,
          pageSize = _this$state3.pageSize,
          orderId = _this$state3.orderId,
          orderDirection = _this$state3.orderDirection,
          filtered = _this$state3.filtered;

      _this.setState({
        pageIndex: pageIndex
      });

      onChange && onChange({
        pageIndex: pageIndex,
        pageSize: pageSize,
        orderId: orderId,
        orderDirection: orderDirection,
        filtered: filtered
      });
      onPageChange && onPageChange(pageIndex);
    });

    _defineProperty(_assertThisInitialized(_this), "debouncePageChange", debounce(_this.onPageChange, 500));

    _defineProperty(_assertThisInitialized(_this), "onSearch", function () {
      var onSearch = _this.props.onSearch;
      var _this$state4 = _this.state,
          pageSize = _this$state4.pageSize,
          orderId = _this$state4.orderId,
          orderDirection = _this$state4.orderDirection,
          filteredTemp = _this$state4.filteredTemp;

      _this.setState({
        pageIndex: 0,
        filtered: filteredTemp
      });

      onSearch && onSearch({
        pageIndex: 0,
        pageSize: pageSize,
        orderId: orderId,
        orderDirection: orderDirection,
        filtered: filteredTemp
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onSearchCntChange", function (_ref) {
      var id = _ref.id,
          value = _ref.value,
          manualSearch = _ref.manualSearch;
      var filteredTemp = _this.state.filteredTemp;
      var filteredTempTrans = JSON.parse(JSON.stringify(filteredTemp));

      if (value !== undefined && value !== null && value !== '') {
        var target = filteredTempTrans.find(function (item) {
          return item.id === id;
        });

        if (target) {
          target.value = value;
        } else {
          filteredTempTrans = [].concat(_toConsumableArray(filteredTempTrans), [{
            id: id,
            value: value
          }]);
        }
      } else {
        filteredTempTrans = filteredTempTrans.filter(function (item) {
          return item.id !== id;
        });
      }

      _this.setState({
        filteredTemp: filteredTempTrans
      }, function () {
        !manualSearch && _this.onSearch();
      });
    });

    var _this$props3 = _this.props,
        _pageIndex = _this$props3.pageIndex,
        _pageSize = _this$props3.pageSize,
        _filtered = _this$props3.filtered,
        _sorted = _this$props3.sorted;
    _this.state = {
      columnResized: [],
      columns: [],
      pageIndex: _pageIndex,
      pageSize: _pageSize,
      sorted: _sorted || [],
      filtered: _filtered || [],
      filteredTemp: _filtered || [],
      orderId: _sorted && _sorted[0] && _sorted[0].id || '',
      orderDirection: _sorted && _sorted[0] && _sorted[0].desc && transformOrderDirection(_sorted[0].desc)
    };
    return _this;
  }

  _createClass(TableView, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props4 = this.props,
          className = _this$props4.className,
          tableID = _this$props4.tableID,
          data = _this$props4.data,
          isSortedOutside = _this$props4.isSortedOutside,
          loading = _this$props4.loading,
          HOCTable = _this$props4.HOCTable,
          rest = _objectWithoutProperties(_this$props4, ["className", "tableID", "data", "isSortedOutside", "loading", "HOCTable"]);

      var _this$state5 = this.state,
          columns = _this$state5.columns,
          pageIndex = _this$state5.pageIndex,
          pageSize = _this$state5.pageSize,
          filtered = _this$state5.filtered,
          sorted = _this$state5.sorted;
      return /*#__PURE__*/React.createElement("div", {
        className: classnames("ReactTableDark", 'tableView', "".concat(prefix, "-SFx-table"), className),
        id: tableID
      }, HOCTable && /*#__PURE__*/React.createElement(HOCTable, _extends({}, rest, {
        data: data,
        columns: columns,
        className: "-highlight",
        page: pageIndex,
        pageSize: Number(pageSize),
        filtered: filtered,
        sorted: sorted,
        onResizedChange: this.onResizedChange,
        onSortedChange: this.debouncedSortChange,
        onEditColumn: this.onEditColumn,
        onPageSizeChange: this.onPageSizeChange,
        onPageChange: this.debouncePageChange,
        onSearch: this.onSearch,
        onSearchCntChange: this.onSearchCntChange,
        isSortedOutside: isSortedOutside,
        LoadingComponent: function LoadingComponent() {
          return /*#__PURE__*/React.createElement(Loading, {
            loading: loading
          });
        },
        NoDataComponent: function NoDataComponent() {
          return /*#__PURE__*/React.createElement(NoData, {
            transInstance: _this2.props.transInstance
          });
        }
      })));
    }
  }]);

  return TableView;
}(Component);

_defineProperty(TableView, "defaultProps", {
  data: [],
  columns: [],
  pageIndex: 0,
  pageSize: 10,
  loading: false,
  HOCTable: ReactTableFilter
});

export default TableView;